export default __webpack_public_path__ + "static/media/Visa_Brandmark_White_RGB_2021.b994986b.png";